import CameraAltIcon from "@mui/icons-material/CameraAlt";
import StopIcon from "@mui/icons-material/Stop";
import BarcodeIcon from "@mui/icons-material/CalendarViewWeek";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

import Scanner from "../scanner/Scanner";
import { getIngredients } from "../../routes/Routes";
import { BarcodeContext } from "../contexts/Barcodecontext";

const fetchNutritionData = async (ingredient, weight) => {
  try {
    const response = await getIngredients({ ingredient, weight });
    console.log(response.data);
    return response.data.data;
  } catch (error) {}
};

//NLEA labelling - How labeling is done
const calculateHealthScore = (nutrientData) => {
  let score = 0;
  const factor = 100 / nutrientData?.totalWeight;

  score += nutrientData?.totalNutrients?.SUGAR?.quantity * factor < 5 ? 1 : -1;
  score += nutrientData?.totalNutrients?.NA?.quantity * factor < 140 ? 1 : -1;
  score += nutrientData?.totalNutrients?.FIBTG?.quantity * factor > 5 ? 1 : 0;
  score += nutrientData?.totalNutrients?.FASAT?.quantity * factor < 3 ? 1 : -1;
  score +=
    !nutrientData?.totalNutrients?.FATRN ||
    nutrientData?.totalNutrients?.FATRN?.quantity === 0
      ? 1
      : -1;
  score += nutrientData?.totalNutrients?.CHOLE?.quantity * factor < 20 ? 1 : -1;
  score +=
    nutrientData?.totalNutrients?.PROCNT?.quantity * factor >= 10 ? 1 : 0;
  score +=
    nutrientData?.totalNutrients?.ENERC_KCAL?.quantity * factor < 200 ? 1 : -1;

  return score;
};

export default function Details({
  productInfo,
  setProductInfo,
  camera,
  setCamera,
}) {
  const { ingredients, setIngredients } = useContext(BarcodeContext);
  const [value, setValue] = useState("");
  const scannerRef = useRef(null);

  // const isHealthy = (product) => {
  //   const ingredientsWithWeights = getIngredientWeights(product);
  //   Promise.all(
  //     ingredientsWithWeights.map((item) =>
  //       fetchNutritionData(item.name, item.weight)
  //     )
  //   ).then((results) => {
  //     const healthStatuses = results.map((data) => {
  //       const score = calculateHealthScore(data);
  //       return {
  //         label: data.ingredients[0].text,
  //         isHealthy: score >= 4,
  //       };
  //     });
  //     setIngredients(healthStatuses);
  //   });
  // };

  // const getIngredientWeights = (product) => {
  //   const servingInt = parseInt(
  //     product.serving_size.match(/\((\d+\.?\d*)\s*(\w+)\)/)[1],
  //     10
  //   );
  //   const unit = product.serving_size.match(/\((\d+\.?\d*)\s*(\w+)\)/)[2];
  //   const totalVolume = servingInt * product.serving_quantity;
  //   return product.ingredients.map((ingredient) => ({
  //     name: ingredient.text,
  //     weight:
  //       ((ingredient.percent_estimate / 100) * totalVolume).toFixed(2) +
  //       " " +
  //       unit,
  //   }));
  // };

  const handleDetectedBarcode = async (barcode) => {
    try {
      //Uncomment this for future ------------------
      navigate(`/products/details/${barcode}`);
      // console.log('called');
      // const response = await sendProductdata({ barcode });
      // console.log(response);
      // const product = response.data.data;
      // if (product) {
      //   setCamera(false);
      //   console.log(product);
      //   isHealthy(product);
      //   console.log("running");
      //   setProductInfo(product);
      // }
    } catch (error) {
      console.error("Error fetching product data:", error);
      alert("Failed to fetch product details.");
    }
  };
  const navigate = useNavigate();

  return (
    <Card sx={{ borderRadius: 3, maxWidth: window.innerWidth }}>
      <CardContent sx={{ padding: 0, mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 3,
            mb: 1,
            paddingRight: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={camera ? <StopIcon /> : <CameraAltIcon />}
            onClick={() => setCamera(!camera)}
            sx={{
              ml: 2,
            }}
          >
            {camera ? (
              "Stop"
            ) : !camera && productInfo ? (
              <span onClick={() => setProductInfo(null)}>Scan Another</span>
            ) : (
              "Scan"
            )}
          </Button>
          <Box>
            <IconButton onClick={() => navigate(-1)}>
              <Icon
                icon="carbon:home"
                style={{ fontWeight: 800, transform: "scale(1.5)" }}
              />
            </IconButton>
          </Box>

          {productInfo && (
            <Typography variant="h5" component="h2">
              {productInfo.product_name}
            </Typography>
          )}
        </Box>
        <Divider sx={{ my: 2 }} />
        {camera && (
          <Box>
            <div
              ref={scannerRef}
              style={{ position: "relative", border: "none" }}
            >
              <canvas
                className="drawingBuffer"
                style={{
                  position: "absolute",
                  top: "0px",
                  border: "none",
                }}
                width="640"
                height="480"
              />
              <Scanner
                scannerRef={scannerRef}
                onDetected={handleDetectedBarcode}
              />
            </div>
            <Box
              sx={{
                position: "fixed",
                bottom: 0,
                height: "20vh",
                backgroundColor: "white",
                width: "100vw",
                color: "blue",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "30px 30px 0 0",
                left: 0,
              }}
            >
              <Box
                sx={{ backgroundColor: "#F6F6F6", borderRadius: 3, padding: 2 }}
              >
                <IconButton>
                  <BarcodeIcon sx={{ color: "#205375" }} />
                </IconButton>
                <span style={{ color: "#205375" }}>Scan with Barcode</span>
              </Box>
            </Box>
          </Box>
        )}
        {!camera && !productInfo && (
          <Box sx={{ margin: 2 }}>
            <Typography align="center" variant="h5">
              Learn more about your product! Scan the barcode to get started!
            </Typography>
          </Box>
        )}
        {
          productInfo && navigate(`/products/details/${productInfo.id}`)
          // <Ingredients productInfo={productInfo} ingredients={ingredients} />
        }
      </CardContent>
    </Card>
  );
}
